import React, { useState } from 'react';
import { Tab, Tabs, Box } from "@mui/material";
import Grid from '@mui/material/Grid2';

const VerticalTabs = ({ tabList = [] }) => {
    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Grid size={12} display="flex" alignItems="stretch" sx={{ height: '100%' }}>
                <Box
                    width="100%"
                    gap={2}
                    display="flex"

                >
                    <Box>
                        <Tabs
                            value={value}
                            orientation="vertical"
                            onChange={handleChange}
                        >
                            {tabList.map((tab) => (
                                <Tab
                                    key={tab.value}
                                    icon={tab.icon}
                                    label={tab.label}
                                    value={tab.value}
                                    disabled={tab.disabled}
                                    sx={{ textAlign: "start", alignItems:"start", padding: 0 }}
                                />
                            ))}
                        </Tabs>
                    </Box>

                    {/* Content Area */}
                    <Box
                        width="100%"
                    >
                        {tabList.map((panel) => (
                            <div
                                key={panel.value}
                                role="tabpanel"
                                id={`vertical-tabpanel-${panel.value}`}
                                aria-labelledby={`vertical-tab-${panel.value}`}
                                style={{
                                    height: '100%',
                                    display: value === panel.value ? 'flex' : 'none',
                                    flexDirection: 'column'
                                }}
                            >
                                <Box sx={{
                                    p: 0,
                                    height: '100%',
                                    flex: 1
                                }}>
                                    {panel.component}
                                </Box>
                            </div>
                        ))}
                    </Box>
                </Box>
        </Grid>
    );
};

export default VerticalTabs;